/**
 * /frontend/src/features/analytics/constants/chartConfig.js
 */

import { CHART_COLORS } from './chartColors';

/**
 * Shared Recharts defaults used across analytics charts.
 */
export const CHART_CONFIG = {
  height: 320,
  margin: { top: 12, right: 18, bottom: 12, left: 12 },
  gridStroke: 'color-mix(in srgb, var(--trae-border) 55%, transparent)',
  axisStroke: 'color-mix(in srgb, var(--trae-text-muted) 55%, transparent)',
  tickFill: CHART_COLORS.textMuted
};

